import React from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAppMeta } from "hooks";

import { useAddShipmentLoadingMutation } from "store/services/shipmentLoadingApi";

import ShipmentLoadingForm from "./ShipmentLoadingComponents/ShipmentLoadingForm";

const ShipmentLoadingCreateScreen = () => {

    const navigate = useNavigate();

    const breadcrumbs = [
        { title: "Shipment Loading", path: "/app/crm/shipment-loading/list" },
        { title: "New Shipment Loading" }];

    const [createShipmentLoading, { isLoading: creatingShipmentLoading }] =
        useAddShipmentLoadingMutation();

    // methods
    const handleAddLoading = async (data) => {

        try {
            const { _id } = await createShipmentLoading(data).unwrap();
            toast.success("Shipment Loading Created !");
            navigate(`/app/crm/shipment-loading/${_id}/detail`)
        } catch (error) {
            toast.error(
                error?.data?.message ?? error.message ?? "Could Not Created Shipment Loading !"
            );
        }
    }
    useAppMeta("New Shipment Loading");
    return (
        <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingShipmentLoading}>
            <BreadcrumbLayout.Paper>
                <ShipmentLoadingForm isBusy={creatingShipmentLoading} onSubmit={handleAddLoading} />
            </BreadcrumbLayout.Paper>

        </BreadcrumbLayout>
    )
}

export default ShipmentLoadingCreateScreen